
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSave, faTimes } from '@fortawesome/free-solid-svg-icons';
import ConfirmModal from '../../components/ConfirmModal';
import { useNavigate } from 'react-router-dom';
import { createTipoProduto } from '../../services/tipoProdutoService';
import { withPermissionAndLevel } from '../../components/withPermission';

const initialState = {
  nome: '',
  status: '',
  controlaEstoque: 'Sim',
  cadastradoPor: '',
  alteradoPor: '',
};

const TipoProdutoCreate = () => {
  const [form, setForm] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [success, setSuccess] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);
  const navigate = useNavigate();

  const validate = () => {
    if (!form.nome.trim()) return 'O nome do tipo de produto é obrigatório.';
    if (form.nome && form.nome.length > 255) return 'O nome deve ter até 255 caracteres.';
    if (form.status && form.status.length > 255) return 'Status deve ter até 255 caracteres.';
    if (form.cadastradoPor && form.cadastradoPor.length > 50) return 'Cadastrado Por deve ter até 50 caracteres.';
    if (form.alteradoPor && form.alteradoPor.length > 50) return 'Alterado Por deve ter até 50 caracteres.';
    return '';
  };

  const handleChange = e => {
    setForm({ ...form, [e.target.name]: e.target.value });
    setError('');
  };

  const handleSubmit = async e => {
    e.preventDefault();
    const validationError = validate();
    if (validationError) {
      setError(validationError);
      return;
    }
    setShowConfirm(true);
  };

  return (
    <div className="w-full bg-white rounded shadow p-6 mt-6">
      <h2 className="text-xl font-bold mb-4">Cadastrar Tipo de Produto</h2>
      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <div>
          <label className="block text-sm font-medium mb-1">Nome *</label>
          <input
            type="text"
            name="nome"
            value={form.nome}
            onChange={handleChange}
            maxLength={255}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
            placeholder="Nome do tipo de produto"
          />
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Status *</label>
          <select
            name="status"
            value={form.status}
            onChange={handleChange}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            <option value="">Selecione o status</option>
            <option value="Ativo">Ativo</option>
            <option value="Inativo">Inativo</option>
          </select>
        </div>
        <div>
          <label className="block text-sm font-medium mb-1">Controla Estoque *</label>
          <select
            name="controlaEstoque"
            value={form.controlaEstoque}
            onChange={handleChange}
            required
            className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-green-400"
          >
            <option value="Sim">Sim</option>
            <option value="Não">Não</option>
          </select>
          <p className="text-xs text-gray-600 mt-1">
            Define se produtos deste tipo terão movimentação automática de estoque
          </p>
        </div>
        {error && <div className="text-red-600 text-sm">{error}</div>}
        {loading && <div className="text-blue-600 text-sm">Salvando...</div>}
        {success && <div className="text-green-600 text-sm">Tipo de Produto cadastrado com sucesso!</div>}
        <div className="flex flex-row gap-1 justify-end mt-2 w-full overflow-x-auto">
          <button type="button" className="p-2 sm:px-4 sm:py-2 rounded bg-gray-200 hover:bg-gray-300 text-gray-700 flex items-center gap-2 w-10 sm:w-auto justify-center" onClick={() => navigate('/tipo-produto')}>
            <FontAwesomeIcon icon={faTimes} />
            <span className="hidden sm:inline">Cancelar</span>
          </button>
          <button type="submit" className="p-2 sm:px-4 sm:py-2 rounded bg-green-600 text-white font-semibold hover:bg-green-700 flex items-center gap-2 w-10 sm:w-auto justify-center" aria-label="Salvar">
            <FontAwesomeIcon icon={faSave} />
            <span className="hidden sm:inline">Salvar</span>
          </button>
        </div>
      </form>
      <ConfirmModal
        isOpen={showConfirm}
        title="Confirmar Cadastro"
        message="Deseja realmente cadastrar este tipo de produto?"
        onCancel={() => setShowConfirm(false)}
        onConfirm={async () => {
          setShowConfirm(false);
          setLoading(true);
          setError('');
          setSuccess(false);
          try {
            await createTipoProduto(form);
            setSuccess(true);
            setTimeout(() => navigate('/tipo-produto'), 1200);
          } catch (err) {
            setError('Erro ao cadastrar tipo de produto.');
          } finally {
            setLoading(false);
          }
        }}
      />
    </div>
  );
};

export default withPermissionAndLevel(TipoProdutoCreate, 'tipo_produto.create', 3, 'Você não tem permissão para criar Tipos de Produto.');
